import { Box, IconButton, Stack, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import { ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken } from "../../utility/tokenUtility";
import CreateNewBtn from "../commoncomponents/CreateNewBtn";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from "../commoncomponents/CustomDialog";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CloseButton from "../commoncomponents/CloseButton";
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from "../commoncomponents/SectionTitle";
import { dialogContent } from "../../utility/message";
import LockResetIcon from '@mui/icons-material/LockReset';
import CustomTooltip from "../commoncomponents/CustomTooltip";

const UnblockUserlist = () => {
     const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [contentDialog, setContentDialog] = useState("");
    const [data, setData] = useState({});
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [gridApi, setGridApi] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setRowData([]);
        setIsLoading(true);
        try {
            // Obtain the bearer token from local storage or your state management system
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await axios.get(
                `${ifacSecurityURL}/api/GraphUserRegistration/GetBlockedUserList?size=1000`,
                config
            );

            setRowData(
                response.data
            );
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleunblock = (data) => {
        setOpenDeleteDialog(true);
        setData(data);
    };

    const actionsRenderer = useCallback(
        ({ data }) => (
            <div>
                {handleunblock && (
                    <CustomTooltip title="Unblock">
                        <IconButton
                            onClick={() => handleunblock(data)}
                            data-testid="delete-button"
                        >
                            <LockResetIcon />
                        </IconButton>
                    </CustomTooltip>
                )}
            </div>
        ),
        [handleunblock]
    );
    const colDefs = [
        {
            field: "firstName",
            headerName: "First Name",
        },
        {
            field: "lastName",
            headerName: "Last Name",
        },
        {
            field: "userEmpNo",
            headerName: "User Employee No",
        },
        {
            field: "staffStatus",
            headerName: "Staff Status",
        },
        {
            field: "companyCode",
            headerName: "Company Code",
        },
        {
            field: "companyName",
            headerName: "Company Name",
        },
        {
            field: "defaultRoleName",
            headerName: "Default Role Name",
        },
        {
            field: "defaultRoleDesc",
            headerName: "Default Role Desc",
        },
        {
           
            field: "actions",
            headerName: "Actions",
            cellRenderer: actionsRenderer,
            sortable: false,
            filter: false,
        }


    ];

    const handleConfirmDelete = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const response = await axios.put(
                `${ifacSecurityURL}/api/reset-failed-attempts/${data.login}`,
                config
            );

            if (response.status === 204) {
                toggleDeleteModal(false)();
                setOpenDialog(true);
                setContentDialog(dialogContent.unblockdelete);
                fetchData();
            }
        } catch (error) {
            if (error.response.status === 400) {
                toggleDeleteModal(false)();
                setOpenDialog(true);
                setContentDialog(error.response.data.detail);
            }
            return error.response;
        }
    };

    const toggleDeleteModal = (newOpen) => () => {
        setOpenDeleteDialog(newOpen);
    };

    const handleDialogClose = () => {
        setOpenDeleteDialog(false);
        setOpenDialog(false);
    };

    return (
        <>
            <PageTitle title={"Unblock Users"} />
            <DefaultCard>
                <Stack
                    mb={1}
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <SectionTitle title={"Unblock Users List"} />

                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                    { rowData.length > 0 ?
                           <Typography>
                           <b>Note <span style={{ color: "red" }}>*</span>:</b> Default password is <b>Welcome@123</b>
                       </Typography> 
                        : null

                        }

                        <RefreshExportButtons
                            exportFunction={() => { }}
                            exportData={rowData}
                            refData={gridApi}
                            handleRefresh={() => fetchData()}
                            title={`Unblock Users`}
                        />
                    </Stack>
                </Stack>
                <Box>
                    <CustomAgGrid
                        rows={rowData}
                        columns={colDefs}
                        ref={gridApi}
                        setGridApi={setGridApi}

                        isLoading={isLoading}
                    />
                </Box>
                <CustomDialog
                    open={openDeleteDialog}
                    onConfirm={handleConfirmDelete}
                    content={dialogContent.unblockuser}
                    cancelBtn={"No"}
                    confirmBtn={"Yes"}
                    onClose={handleDialogClose}
                />
                <CustomDialog
                    open={openDialog}
                    content={contentDialog}
                    confirmBtn={"Ok"}
                    onConfirm={handleDialogClose}
                />
            </DefaultCard>
            <CloseButton />
        </>
    );
};

export default UnblockUserlist;
